import React from 'react'

interface Props {
    tickets: any[];
    selectedTicketIndex: number;
    onTicketChange: (index: number) => void;
}

const TicketInfo: React.FC<Props> = ({ tickets, selectedTicketIndex, onTicketChange }) => {
    const ticket = tickets[selectedTicketIndex];

    if (!ticket) {
        return (
            <div className="overflow-hidden bg-white shadow sm:rounded-lg">
                <div className="px-4 py-6 sm:px-6">
                    <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-500">No ticket selected or available.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="overflow-hidden bg-white shadow sm:rounded-lg">
            <div className="px-4 py-6 sm:px-6">
                {tickets.length > 1 && (
                    <div className="flex flex-col items-center mt-4">
                        <label htmlFor="ticket-select" className="block text-sm font-medium leading-6 text-gray-900">
                            Select Ticket
                        </label>
                        <select
                            id="ticket-select"
                            name="ticket-select"
                            className="mt-2 block w-full max-w-xs rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            value={selectedTicketIndex}
                            onChange={(e) => onTicketChange(Number(e.target.value))}
                        >
                            {tickets.map((_ticket, index) => (
                                <option key={index} value={index}>
                                    Ticket #{index + 1}
                                </option>
                            ))}
                        </select>
                    </div>
                )}
            </div>

            <div className="px-4 py-6 sm:px-6">
                <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-500 font-bold">Ticket details:</p>
            </div>

            <div className="border-t border-gray-100">
                <dl className="divide-y divide-gray-100">
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-900">QR Code</dt>
                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                            {ticket.qrCode && (
                                <img src={ticket.qrCode} alt="Ticket QR Code" width={128} height={128} />
                            )}
                        </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-900">Ticket ID</dt>
                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{ticket.id?.slice(-9)}</dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-900">Package</dt>
                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{ticket.package}</dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-900">Link</dt>
                        <dd className="mt-1 text-sm leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                            <a target="_blank" href={ticket.link} rel="noreferrer">{ticket.link}</a>
                        </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-900">Price</dt>
                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">$ {ticket.price}</dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-900">Amount Paid</dt>
                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">$ {ticket.ticketValue}</dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-900">Bonus Rate</dt>
                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{(ticket.ticketBonusRate ?? 0) * 100} %</dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-900">Gender</dt>
                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{ticket.gender}</dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-900">Time of Purchase</dt>
                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{ticket.created_at}</dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-900">Updated</dt>
                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{ticket.updated_at}</dd>
                    </div>
                </dl>
            </div>
        </div>
    );
};

export default TicketInfo;
